<template>
<!--  <div class="Vlt-template Vlt-template&#45;&#45;sidenav">-->
    <main class="Vlt-main Vlt-main--dark mainAdminContainer" ref="mainContainer">
      <section v-if="isAdmin && isAdminLayout">
        <h3>
          <span>
            <vlt-icon class="Vlt-black Vlt-margin--bottom1" icon="phone-garland"/>
          </span>&nbsp;
          <span>{{$t('message.dashboard.adminDashboard.manage_calls')}}</span>
<!--          <span v-else>{{$t('message.dashboard.searchNumber.search_number')}}</span>-->
        </h3>
        <hr class="hr--short">
      </section>

      <div v-if="isAdmin">
        <div v-if="isAdminLayout">
          <AdminSearchAndListBridges />
        </div>
        <div v-else>
          <UserSearchAndHistory />
        </div>
      </div>
      <div v-else>
        <UserSearchAndHistory />
      </div>

    </main>
<!--  </div>-->
</template>

<script>
import {
  VltIcon,
  VltButton,
} from '@vonagevolta/vue';
import { mapGetters } from 'vuex';
import Sidebar from 'Components/Sidebar.vue';
import AdminSearchAndListBridges from 'Components/common/AdminSearchAndListBridges.vue';
import UserSearchAndHistory from 'Components/common/UserSearchAndHistory.vue';

export default {
  name: 'ManageCalls',
  components: {
    VltIcon,
    VltButton,
    Sidebar,
    AdminSearchAndListBridges,
    UserSearchAndHistory
  },
  props: {

  },
  watch: {
    isAdminLayout(current) {
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'isLoggedIn',
      isAdmin: 'isAdmin',
      userStatus: 'getUserStatus',
      isAdminLayout: 'getIsAdminLayout'
    }),
  },
  created() {
    if (!this.isAdmin) {
        this.$router.push({name: 'userCalls'})
    }
  }
};
</script>

<style lang="scss" scoped>
  .app-main {
    flex: 1;
    //height: 100vh;
    overflow: hidden;
    padding: 15px 20px 20px 10px;
    //height: calc(100vh - 70px);
  }

  .flexContainer {
    display: flex;
    align-items: stretch
  }

  .linkImg {
    width: 130px;
  }

  .Vlt-margin--left1 {
    margin-left: 10px;
  }

  .Vlt-margin--left2 {
    margin-left: 20px;
  }

  .stretch-height {
    height: 100%;
  }

  .Vlt-template {
    margin-top: 20px;
  }
.mainAdminContainer {
  height: 82vh;
}
.Vlt-main {
  overflow: scroll;
  overflow-x: hidden;
}
.Vlt-main::-webkit-scrollbar {
  width: 0px; /* remove scrollbar space */
}
</style>
